export default "__VITE_PUBLIC_ASSET__8faf76c9__"